<div>
  Wollen Sie dem Benutzer wirklich alle Rechte für die Abteilung "{{data.departments[0].name}}" entziehen?
</div>
<div mat-dialog-actions class="flex-end">
  <button mat-raised-button color="warn" (click)="deleteUserDepartmentRights()">Löschen</button>
  <button mat-raised-button color="success" [mat-dialog-close]="">Abbrechen</button>
</div>
